import {Collections} from '../interfaces/collections';
import {PROJECT_PERMISSIONS} from './project-permissions';

export const PROJECT_PERMISSIONS_MODULE = {
  id: Collections.ProjectPermissions,
  collectionGroup: true,
  ...PROJECT_PERMISSIONS
}
